// extracted by mini-css-extract-plugin
export default {"wrapper":"IR-z","availablePromoMessagesLabel":"JR-z","promoMessageList":"KR-z","promoMessage":"LR-z","appliedPromoMessage":"MR-z","promoMessageAmount":"NR-z"};